import type { IconData } from '@stacksjs/iconify-core'

export const translate: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m230.2 356.821l14.425-30.654a574 574 0 0 1-40.421-44.777q15.881-21.418 29.594-43.958A543.4 543.4 0 0 0 292.212 104H344V72H200V16h-32v56H16v32h59.77a545.1 545.1 0 0 0 71.448 153.959a563 563 0 0 0 20.566-27.031A512.7 512.7 0 0 1 109.13 104h149.737c-29.727 97.53-84.546 169.208-126.64 213.119c-48.993 51.107-91.952 76.86-92.38 77.114l1.621 2.738L48 408l8.14 13.774c1.873-1.106 46.474-27.729 98.389-81.68q15.38-15.982 29.44-32.931a608 608 0 0 0 46.231 49.658M333.722 200L328 212.516L209.379 472h35.185l36.571-80h141.73l36.571 80h35.185L370.278 200ZM328 360h-32.236L328 289.484l24-52.5L408.236 360Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default translate
